<script lang="ts" generics="ROW">
    import {getGridContext} from '../grid.context';
    import type {Header} from '@tanstack/svelte-table';
    import {isLastColumnInMainColumnGroup} from '../utils';

    export let header: Header<ROW, unknown>;

    const {settings: {columnPinningEnabled, mainGroupsDivided, columnResizingEnabled, colorAccented, condensed}} = getGridContext();

    $: isColumnGroupBorder = mainGroupsDivided && isLastColumnInMainColumnGroup(header.column);
    $: pinnedLeft = columnPinningEnabled && header.column.getIsPinned() === 'left';
    $: leftOffset = (columnPinningEnabled || columnResizingEnabled) ? `${header.getStart('left')}px` : '0px';
</script>

<div role="columnheader"
     class="kp-generic-grid-footer-header-cell"
     class:condensed
     class:column-group-border={isColumnGroupBorder}
     class:color-accented={colorAccented}
     class:pinned-left={pinnedLeft}
     style:width="{header.getSize()}px"
     style:--left-offset={leftOffset}>

    <slot/>
</div>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";

    @default-border-width: 1px;

    .kp-generic-grid-footer-header-cell {
        position: relative;
        flex: none; // row is flexbox, cell is fixed size

        padding: var(--default-grid-cell-padding);
        line-height: var(--default-line-height);

        white-space: nowrap;
        align-content: center;
        font-weight: bold;
        text-align: center;
        background-color: #ffffff;

        border-bottom: @default-border-width solid @themed-border-muted;
        border-right: var(--col-border-width, @default-border-width) solid @themed-border-muted;

        &:empty {
            padding: 0;
            display: none;
        }

        &.condensed {
            padding: 3px;
            font-size: 12px;

            &:empty {
                padding: 0;
            }
        }

        &.column-group-border {
            --col-border-width: 2px;
        }

        &.pinned-left {
            position: sticky;
            left: var(--left-offset, 0px);
            z-index: 5; // pinned have to have z-index higher than non-pinned and higher then elements inside cells, TODO: fix overlapping resizer between 2 pinned cols
        }
    }
</style>